import { render } from "./DefaultTabs.vue?vue&type=template&id=2aa133a3"
import script from "./DefaultTabs.vue?vue&type=script&lang=js"
export * from "./DefaultTabs.vue?vue&type=script&lang=js"

import "./DefaultTabs.vue?vue&type=style&index=0&id=2aa133a3&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
